export const availableFirst = (searchResults) => searchResults.sort((a, b) => {
  return Number(b.isAvailable) - Number(a.isAvailable);
});
